import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import AboutCeo from "./sections/AboutCeo";
import AboutEyePriority from "./sections/AboutEyePriority";
import AboutClinicVd from "./sections/AboutClinicVd";
// import MeetDoctors from "../main/sections/MeetDoctors";
import AboutXatirchi from "./sections/AboutXatirchi";
import AboutSamarkand from "./sections/AboutSamarkand";
import AppoinmentSection from "../../components/appointment-section/AppoinmentSection";
import AboutClinicForm from "./sections/AboutClinicForm";
import AboutGallery from "./sections/AboutGallery";
import Location from "../../sections/Location";
import StatsSection from "../../sections/StatsSection";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerAboutClinic",
  },
];

export default function AboutClinic() {
  const { t } = useTranslation();

  return (
    <StyledAboutClinic>
      <PageTop title={t("aboutClinicTitle")} linkList={linkChain} />
      <AboutCeo />
      <StatsSection />
      <AboutXatirchi />
      <AppoinmentSection />
      <AboutSamarkand />
      <AboutEyePriority />
      <AboutClinicVd />
      {/* <MeetDoctors /> */}
      <AboutGallery />
      <AboutClinicForm />
      <Location />
    </StyledAboutClinic>
  );
}

const StyledAboutClinic = styled.main``;
